import { render, staticRenderFns } from "./EditAlternatives.vue?vue&type=template&id=62e6550e&"
import script from "./EditAlternatives.vue?vue&type=script&lang=js&"
export * from "./EditAlternatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports